import { render, staticRenderFns } from "./medkitlogDate.vue?vue&type=template&id=40b668d5"
import script from "./medkitlogDate.vue?vue&type=script&lang=js"
export * from "./medkitlogDate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports